import styled from 'styled-components';
import login from '../../assets/backgrounds/login.jpg';
import {Colors} from "../../components/constants";

export const Background = styled.div`
  background-image: url("${login}");
  background-size: cover;
  min-height: 100%;
  background-color: ${Colors.primary};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const SignInCardContainer = styled.div`
  background-color: ${Colors.primary};
  box-shadow: 0 0 50px 10px rgba(0,0,0,0.2);
  width: 450px;
  margin: 30px 0 30px 0;
  min-height: 85vh;
  overflow-y: auto;
`;